import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface GlobalState {
  electionId: string | null;
}

const createDefaultGlobalState = (): GlobalState => ({
  electionId: null,
});

const initialState = createDefaultGlobalState();

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setSelectedElectionId: (state, action: PayloadAction<string>) => {
      state.electionId = action.payload;
    },
  },
});

export default globalSlice.reducer;

export const { setSelectedElectionId } = globalSlice.actions;

export const selectSelectedElectionId = (state: { global: GlobalState }) => state.global.electionId;
